<template>
  <div>
    <b-card title="Pasos">
      <form data-vv-scope="steps" class="pb-5" autocomplete="off" v-on:submit.prevent >
        <div v-if="form.stepType === stepTypesMap.OFFICE">
          <div class="row">
            <div class="col-6">
              <label>Este tipo de paso sera una oficina</label>
              <div class="d-flex justify-content-around">
                <b-form-radio
                  v-model="form.officeType"
                  plain
                  name="some-radios3"
                  value="I"
                >
                  Interna
                </b-form-radio>
                <b-form-radio
                  v-model="form.officeType"
                  plain
                  name="some-radios4"
                  value="P"
                >
                  De partes
                </b-form-radio>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!readOnly" class="row">
          <div class="col-3">
            <vs-select
              class="w-100"
              autocomplete
              label="Tipo de paso"
              name="stepType"
              v-model.number="form.stepType"
              :danger="errors.has('steps.stepType')"
              :danger-text="errors.first('steps.stepType')"
              v-validate="'required'"
              ref="stepType"
            >
              <vs-select-item
                v-for="type in stepTypesAvalaibles"
                :key="type.opcionId"
                :value="type.valor"
                :text="type.descripcion"
              />
            </vs-select>
          </div>
          <div
            class="col-6"
            v-if="form.stepType === stepTypesMap.OFFICE"
          >
            <list-offices
              class="w-100 mb-1"
              autocomplete
              label="Oficina del responsable (*)"
              name="groupStep"
              v-model="form.groupStep"
              data-vv-as="oficina"
              :typeList="form.officeType === 'I' ? 99 : 98"
              validate-lider
              withFilters
              :officeType="form.officeType === 'I' ? 'numInt' : 'numOf'"
              ref="groupStep"
              :danger="errors.has('steps.groupStep')"
              :danger-text="errors.first('steps.groupStep')"
              v-validate="{ required: form.stepType === stepTypesMap.OFFICE }"
            />
            <small class="text-danger">
              Si le falta una oficina, favor notificar al equipo de Soporte
              para que verifiquen que esté correctamente configurada
            </small>
          </div>
          <div class="col-6" v-if="form.stepType === stepTypesMap.GROUP">
            <list-groups
              class="w-100"
              autocomplete
              label="Grupo del responsable"
              name="groupStep"
              ref="groupStep"
              :typeList="form.stepType"
              v-model="form.groupStep"
              :danger="errors.has('steps.groupStep')"
              :danger-text="errors.first('steps.groupStep')"
              v-validate="{ required: form.stepType === stepTypesMap.GROUP }"
            />
          </div>
          <div class="col-6" v-if="form.stepType === stepTypesMap.USER">
            <list-user
              class="w-100"
              autocomplete
              label="Usuario"
              name="userStep"
              v-model="form.userStep"
              ref="userStep"
              :danger="errors.has('steps.userStep')"
              :danger-text="errors.first('steps.userStep')"
              v-validate="{ required: form.stepType === stepTypesMap.USER }"
            />
          </div>
          <div class="col-3">
            <vs-select
              class="w-100"
              autocomplete
              label="Tipo de rol"
              name="rolType"
              v-model="form.rolType"
              :danger="errors.has('steps.rolType')"
              :danger-text="errors.first('steps.rolType')"
              v-validate="'required'"
            >
              <vs-select-item
                v-for="rol in rolTypesAvalaibles"
                :key="rol.opcionId"
                :value="rol.valor"
                :text="rol.descripcion"
              />
            </vs-select>
          </div>
        </div>
        <div v-if="!readMode" class="row mb-3">
          <div class="col-12 d-flex align-items-end justify-content-end">
            <b-button
              data-cy="configure-sign"
              variant="info"
              v-if="exampleFile"
              :disabled="loading"
              class="mr-2"
              v-b-modal="'config-signs'"
            >
              Configurar firmas
            </b-button>
            <UploadFile
              v-if="!readOnly"
              class="mt-2 mr-3"
              permission="*"
              color="secondary"
              text="Cargar archivo de muestra"
              accept="*"
              v-model="filePreview"
              upload-to="ed"
              v-tooltip="'Agregar archivo preview'"
            />
            <b-button
              v-if="!readOnly"
              data-cy="add-step"
              variant="primary"
              icon="add"
              :disabled="loading"
              v-on:click="addStep()"
            >
              {{ loading ? 'Agregando paso...' : 'Agregar paso' }}
            </b-button>
          </div>
        </div>
        <div class="row scroll"  :class="{ 'minHeigth' : !readMode }"  v-if="steps.length">
          <div class="col-4 mb-2" v-for="(step, index) in steps" :key="`step-${index}`">
            <div class="step-wrapper">
              <span class="step-number" data-cy="step">{{ step.numeroPaso }}</span>
              <span v-if="readMode" class="step-delete">
                <vs-icon
                  icon="info"
                  size="small"
                  bg="white"
                  round
                  v-b-tooltip.hover.left="'Ver detalles'"
                  @click="configureStep(step)"
                />
              </span>
              <span v-if="!readMode" class="step-delete">
                <vs-icon
                  data-cy="configure-step"
                  title="Configurar paso"
                  icon="settings"
                  size="small"
                  bg="white"
                  round
                  @click="configureStep(step)"
                />
                <vs-icon
                  icon="highlight_off"
                  size="small"
                  bg="white"
                  color="danger"
                  round
                  @click="removeStep(step)"
                />
              </span>
              <div
                class="cursor-default text-center step-name"
                v-tooltip="(step.subrogado && step.subrogado.length) ? 'Subrogado' : ''"
              >
                <span v-tooltip="'Responsable anterior'" class="responsible">
                  {{ (step.subrogado && step.subrogado.length) ? step.responsable : '' }}
                </span><br>
                {{
                 (step.subrogado && step.subrogado.length) ?
                  `${step.subrogado} (S)` :
                  `${step.responsable}`
                }}
                <span
                  class="cursor-default"
                  v-tooltip="'Cantidad de usuarios en el grupo'"
                  v-if="step.aprobacionesTipoPasoId === stepTypesMap.GROUP"
                >
                  {{ `(${step.grupoUsuarios})` }}
                </span>
                <br>
                <span
                  class="cursor-default"
                  v-if="step.subrogadoDesde && step.subrogadoDesde.length"
                >
                  Desde: <b>{{ step.subrogadoDesde | dateFormat }}</b>
                </span>
                <br>
                <span
                  class="cursor-default"
                  v-if="step.subrogadoHasta && step.subrogadoHasta.length"
                >
                  Hasta: <b>{{ step.subrogadoHasta | dateFormat }}</b>
                </span>
              </div>
              <div class="step-amount" v-if="flowType === 'P'">
                <span>
                  {{ step.desdePrecio }} {{ step.desdePrecioMoneda }}
                </span>
              </div>
              <div class="step-types">
                <span
                  class="bg-secondary badges"
                  v-if="step.aprobacionesTipoPasoId === stepTypesMap.USER"
                > Usuario </span>
                <span
                  class="blue badges"
                  v-if="step.aprobacionesTipoPasoId === stepTypesMap.GROUP"
                > Grupo </span>
                <span
                  class="blue badges"
                  v-if="step.aprobacionesTipoPasoId === stepTypesMap.OFFICE"
                > Oficina </span>
                <span
                  v-if="step.distributed"
                  class="bg-warning badges"
                  v-b-tooltip.hover="'Distribuido: se asigna a 1 persona del grupo secuencialmente'"
                >
                  <vs-icon icon="share" size="12px" />
                </span>
              </div>
              <div class="step-roles">
                <span
                  class="bg-info badges"
                  v-if="step.aprobacionesTipoRolId === rolTypesMap.CONFIGURATOR || parseInt(step.aprobacionesTipoRolId) === rolTypesMap.CONFIGURATOR"
                >
                  Configurador
                </span>
                <span
                  class="bg-info badges" v-if="step.aprobacionesTipoRolId === rolTypesMap.APPROVER"
                >
                  Aprobador
                </span>
                <span
                  class="bg-success badges"
                  v-if="step.aprobacionesTipoRolId === rolTypesMap.SIGNER
                   && step.aprobacionesTipoPasoId !== stepTypesMap.OFFICE"
                >
                  Firmante
                </span>
                <span
                  class="bg-success badges"
                  v-if="step.aprobacionesTipoRolId === rolTypesMap.SIGNER
                   && step.aprobacionesTipoPasoId === stepTypesMap.OFFICE"
                >
                  Numerar/tramitar
                </span>
                <span
                  class="bg-warning badges"
                  v-if="step.aprobacionesTipoRolId === rolTypesMap.REVIEWER"
                >
                  Revisor
                </span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!readMode && error !== ''" class="pt-5 mt-5 text-right text-danger">
          <span class="mt-5"> {{ error }} </span>
        </div>
      </form>
    </b-card>
    <b-modal
      hide-footer
      no-close-on-backdrop
      hideHeaderClose
      centered
      size="lg"
      ref="configModal"
    >
      <ConfigureStepModal
        ref="configureStep"
        @close="$refs.configModal.hide()"
        :flowType="flowType"
        :step="stepToConfigure"
        :file="filePreview"
        :steps="steps"
        :signatures="signatureSteps"
        @update-sign-position="updateSignPosition"
        :reference="reference"
        :modifyStep="modifyStep"
        :readOnly="readOnly"
      />
    </b-modal>
    <ConfigureSigns
      :step="stepToConfigure"
      :file="exampleFile"
      :steps="steps"
      :signatures="signatureSteps"
      @update-sign-position="updateSignPosition"
      @cancel-action="cancelModification"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import StepTypes, { CAN_REPEAT_TYPES } from '@/febos/chile/dnt/mixins/StepTypes';
import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import ListUser from '@/febos/chile/lists/components/ListUser';
import { getUsersByGroup } from '@/febos/servicios/api/empresas.api';
import ConfigureStepModal from '@/febos/chile/approvals/vistas/modals/ConfigureStepModal';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import ConfigureSigns from '@/febos/chile/approvals/vistas/modals/ConfigureSigns';
import ListOffices from '@/febos/chile/lists/components/ListOffices.vue';

export default {
  name: 'Steps',
  components: {
    ListOffices,
    UploadFile,
    ListGroups,
    ListUser,
    ConfigureStepModal,
    ConfigureSigns
  },
  props: ['flowType', 'reference', 'errorOnSave', 'readOnly', 'examplePdf'],
  data() {
    return {
      stepTypesCodes: StepTypes,
      rolTypesCodes: RolTypes,
      filePreview: {},
      signs: {},
      signatureSteps: {},
      stepTypesMap: StepTypes,
      rolTypesMap: RolTypes,
      steps: [],
      stepsOriginal: [],
      form: {
        officeType: 'I',
        stepType: StepTypes.USER,
        groupStep: '',
        userStep: '',
        rolType: RolTypes.APPROVER
      },
      loading: false,
      error: '',
      stepToConfigure: {},
      groupUsers: []
    };
  },
  watch: {
    steps() {
      this.$emit('steps', this.steps);
    },
    'form.officeType': function (newValue) {
      this.$emit('set-office-type', newValue);
    },
    filePreview() {
      this.$emit('filePreview', this.filePreview);
    },
    errorOnSave(val) {
      this.error = val;
    },
    // eslint-disable-next-line func-names
    'form.stepType': function () {
      const { rolTypesAvalaibles } = this;
      const { rolType } = this.form;
      if (!rolTypesAvalaibles.find((item) => item.valor === rolType)) {
        this.form.rolType = rolTypesAvalaibles[0].valor;
      }
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Approvals', [
      'aprovalTemplate',
      'stepTypes',
      'stepRoles'
    ]),
    stepTypesAvalaibles() {
      return this.stepTypes.filter((item) => item.plantilla);
    },
    actualStepType() {
      const tipes = this.stepTypes;
      const stepType = tipes.find((item) => item.valor === this.form.stepType);
      return stepType;
    },
    rolTypesAvalaibles() {
      const stepType = this.actualStepType;
      if (stepType && stepType.tipoRol && stepType.tipoRol.length > 0) {
        const avalaiblesTipesId = stepType.tipoRol;
        if (stepType.valor === this.stepTypesCodes.OFFICE) {
          return this.stepRoles
            .filter((item) => avalaiblesTipesId.includes(item.valor))
            .map((rol) => {
              if (rol.valor === this.rolTypesCodes.SIGNER) {
                return {
                  ...rol,
                  descripcion: 'Numerar/Tramitar'
                };
              }
              return rol;
            });
        }
        return this.stepRoles.filter((item) => avalaiblesTipesId.includes(item.valor));
      }
      return this.stepRoles;
    },
    readMode() {
      return this.readOnly;
    },
    exampleFile() {
      const path = this.filePreview?.path || this.examplePdf;
      if (path) {
        return {
          path,
          name: 'Example.pdf'
        };
      }
      return null;
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'getStepTypes',
      'getStepRoles'
    ]),
    updateSignPosition(sign) {
      this.signatureSteps[sign.id] = sign;
      this.steps = this.steps.map((step) => {
        let stepMap = step;
        if (step.id === sign.id) {
          stepMap = {
            ...step,
            x: parseInt(sign.x, 10),
            y: parseInt(sign.y, 10),
            pagina: sign.page
          };
          return stepMap;
        }
        return stepMap;
      });
    },
    cancelModification() {
      this.signatureSteps = this.stepsOriginal
        .filter((step) => step.aprobacionesTipoRolId === RolTypes.SIGNER)
        .map((stepMap) => ({
          responsibleId: stepMap.id,
          responsible: stepMap.responsable,
          id: stepMap.id,
          stepType: stepMap.aprobacionesTipoPasoId,
          rolType: stepMap.aprobacionesTipoRolId,
          stepNumber: stepMap.numeroPaso,
          name: stepMap.responsable,
          page: stepMap.pagina,
          configuration: stepMap.configuration,
          x: stepMap.x || null,
          y: stepMap.y || null
        }))
        .reduce((index, option) => ({
          ...index,
          [option.id]: option
        }), {});
      this.steps = this.stepsOriginal
        .map((stepMap) => ({
          ...stepMap,
          pagina: stepMap.pagina,
          x: stepMap.x || null,
          y: stepMap.y || null
        }));
    },
    mapData() {
      this.steps = (this.aprovalTemplate.pasos || []).map((step, index) => {
        const isRepeable = CAN_REPEAT_TYPES.includes(step.aprobacionesTipoPasoId);
        let id = `${step.tipoValorResponsableId}&${step.aprobacionesTipoPasoId}${step.aprobacionesTipoRolId}`;
        if (isRepeable) {
          id = `${parseInt(step.numeroPaso, 10)}${step.tipoValorResponsableId}&${step.aprobacionesTipoPasoId}${step.aprobacionesTipoRolId}`;
        }
        return {
          id,
          index,
          stepId: `${parseInt(step.numeroPaso, 10)}${step.tipoValorResponsableId}&${step.aprobacionesTipoPasoId}${step.aprobacionesTipoRolId}`,
          numeroPaso: parseInt(step.numeroPaso, 10),
          gatillaciones: (step.gatillaciones || []).map((consequence) => ({
            key: `${consequence.gatillador}&${consequence.gatillador_proceso}`,
            aprobacionesGatilladorId: consequence.gatillador,
            aprobacionesGatilladorProcesoId: consequence.gatillador_proceso,
            estado: consequence.tipo,
            proceso: consequence.proceso,
            configuracion: consequence.configuracion
          })),
          grupoUsuarios: step.participantes,
          cantidadMinAprobacion: parseInt(step.cantidadMinAprobacion, 10),
          tipoValorResponsableId: step.tipoValorResponsableId,
          responsable: step.responsable,
          aprobacionesTipoRolId: parseInt(step.aprobacionesTipoRolId, 10),
          aprobacionesTipoPasoId: parseInt(step.aprobacionesTipoPasoId, 10),
          demoraMaxHoras: parseInt(step.demoraMaxHoras, 10),
          desdePrecioMoneda: step.desdePrecioMoneda,
          desdePrecio: step.desdePrecio,
          redirigirFlujo: step.redirigirFlujo,
          subrogadoId: step.subrogadoId,
          subrogado: step.subrogado,
          subrogadoDesde: step.subrogadoDesde,
          subrogadoHasta: step.subrogadoHasta,
          pagina: step.pagina,
          configuration: step.configuration,
          distributed: step.distributed == 1,
          x: step.x,
          y: step.y
        };
      });
      this.stepsOriginal = [...this.steps];
      this.signatureSteps = this.steps
        .filter((step) => step.aprobacionesTipoRolId === RolTypes.SIGNER)
        .map((stepMap) => ({
          responsibleId: stepMap.id,
          responsible: stepMap.responsable,
          id: stepMap.id,
          configuration: stepMap.configuration,
          stepType: stepMap.aprobacionesTipoPasoId,
          rolType: stepMap.aprobacionesTipoRolId,
          stepNumber: stepMap.numeroPaso,
          name: stepMap.responsable,
          page: stepMap.pagina || null,
          x: stepMap.x || null,
          y: stepMap.y || null
        }))
        .reduce((index, option) => ({
          ...index,
          [option.id]: option
        }), {});
    },
    configureStep(step) {
      this.stepToConfigure = step;
      this.$refs.configModal.show();
      setTimeout(() => {
        try {
          this.$refs.configureStep.init();
        } catch (e) {
          console.error(e);
        }
      }, 700);
    },
    modifyStep(step, newData) {
      const stepIndex = this.steps.findIndex((currentStep) => (currentStep.stepId === step.stepId));
      this.steps[stepIndex] = newData;
      this.stepToConfigure = newData;
      this.signatureSteps = this.steps
        .filter((stepFilter) => stepFilter.aprobacionesTipoRolId === RolTypes.SIGNER)
        .map((stepMap) => ({
          responsibleId: stepMap.id,
          responsible: stepMap.responsable,
          id: stepMap.id,
          stepType: stepMap.aprobacionesTipoPasoId,
          rolType: stepMap.aprobacionesTipoRolId,
          stepNumber: stepMap.numeroPaso,
          name: stepMap.responsable,
          page: stepMap.pagina || null,
          x: stepMap.x || null,
          y: stepMap.y || null
        }))
        .reduce((index, option) => ({
          ...index,
          [option.id]: option
        }), {});
      this.$refs.configModal.hide();
    },
    findDuplicatedSteps(step) {
      let duplicated = false;
      const stepIndex = this.steps.findIndex((currentStep) => (currentStep.stepId === step.stepId));
      const previousStep = this.steps[stepIndex - 1];
      const nextStep = this.steps[stepIndex + 1];
      if (this.steps.length > 1 && previousStep?.id === nextStep?.id) {
        duplicated = true;
      }
      return duplicated;
    },
    removeStep(step) {
      this.error = '';
      const duplicated = this.findDuplicatedSteps(step);
      if (duplicated) {
        this.error = 'No puedes eliminar un paso que deje dos pasos iguales juntos';
        return;
      }
      this.steps = this.steps.filter((item) => item.stepId !== step.stepId);
      this.steps.forEach((stepX, index) => {
        const stepIndex = stepX;
        stepIndex.numeroPaso = index + 1;
        stepIndex.index = index;
        if (+stepIndex.numeroPaso === 1) {
          // El primer y ultimo paso no deben tener consecuencias
          stepIndex.gatillaciones = [];
        }
      });
      const {
        [step.id]: ignored,
        ...signaturesDropped
      } = this.signatureSteps;
      this.signatureSteps = signaturesDropped;
    },
    repeatedStep(responsibleStep) {
      if (!responsibleStep) return false;
      let repeated = false;
      const canRepeat = CAN_REPEAT_TYPES.includes(responsibleStep.id);
      if (!canRepeat) {
        const stepId = `${responsibleStep.id}&${this.form.stepType}${this.form.rolType}`;
        if (stepId === this.steps[this.steps.length - 1]?.id) {
          repeated = true;
          this.error = 'No pueden haber dos pasos iguales de forma continua';
          this.loading = false;
        }
        return repeated;
      }
      return repeated;
    },
    modifyData() {
      this.$refs.configModal.hide();
    },
    responsibleStep() {
      let responsible;
      switch (this.form.stepType) {
        case StepTypes.USER:
          responsible = this.$refs.userStep.getOption();
          break;
        case StepTypes.OFFICE:
        case StepTypes.GROUP:
          responsible = this.$refs.groupStep.getOption();
          break;
        case StepTypes.USER_SEND_APPROVAL:
        case StepTypes.LEADERSHIP_SENDING_APPROVAL:
        case StepTypes.GROUP_LEADER_SENDING_APPROVAL:
        case StepTypes.USER_CREATOR_DOC:
        case StepTypes.LEADERSHIP_CREATOR_DOC:
        case StepTypes.GROUP_LEADER_CREATOR_DOC:
        case StepTypes.PERSON_FROM_DNT_PRE_DEFINED:
        case StepTypes.PERSON_FROM_DOC_PRE_DEFINED:
        default:
          responsible = {
            id: this.form.stepType,
            label: this.$refs.stepType.valuex
          };
          break;
      }
      return responsible;
    },
    async addStep() {
      this.error = '';
      this.loading = true;

      if (this.steps.find((step) => step.aprobacionesTipoPasoId === StepTypes.OFFICE)) {
        this.error = 'Oops! El último paso debe ser la oficina y ya la agregaste';
        this.loading = false;
        return;
      }
      const isValid = await this.$validator.validateAll('steps');
      if (!isValid) {
        this.loading = false;
        return;
      }
      const hasSigner = this.steps.some(
        (step) => step.aprobacionesTipoRolId === RolTypes.SIGNER && step.aprobacionesTipoPasoId !== StepTypes.OFFICE
      );
      if (this.steps.length && this.steps[0].aprobacionesTipoPasoId === StepTypes.OFFICE) {
        this.error = 'Oops! No puedes agregar una oficina como primer paso';
        this.loading = false;
        return;
      }
      const hasOffice = this.steps.some(
        (step) => step.aprobacionesTipoRolId === RolTypes.SIGNER && step.aprobacionesTipoPasoId === StepTypes.OFFICE
      );
      if (this.form.stepType === StepTypes.OFFICE && !hasSigner) {
        this.loading = false;
        this.error = 'No se puede realizar las acciones de la oficina sin un paso de rol firmante';
        return;
      }

      if (hasOffice && !hasSigner) {
        this.loading = false;
        this.error = 'No se puede realizar las acciones de la oficina sin un paso de rol firmante';
        return;
      }

      const responsibleStep = this.responsibleStep();

      const repeatedStep = this.repeatedStep(responsibleStep);
      if (repeatedStep) {
        this.loading = false;
        return;
      }

      if (this.form.stepType === StepTypes.GROUP) {
        const { data: { usuarios: users } } = await getUsersByGroup({
          empresaId: this.company.id,
          pagina: 1,
          filas: 9999,
          groupId: responsibleStep.id
        });
        this.groupUsers = users;
      }

      if (!this.groupUsers.length && this.form.stepType === StepTypes.GROUP) {
        this.error = 'No se puede agregar un grupo que no contenga usuarios';
        this.loading = false;
        return;
      }
      const stepNumber = this.steps.length + 1;
      const stepConfig = this.stepTypesAvalaibles.find((item) => item.valor == this.form.stepType);
      const step = {
        id: `${responsibleStep.id}&${this.form.stepType}${this.form.rolType}`,
        stepId: `${stepNumber}${responsibleStep.id}&${this.form.stepType}${this.form.rolType}`,
        numeroPaso: stepNumber,
        gatillaciones: [],
        grupoUsuarios: this.groupUsers.length.toString(),
        cantidadMinAprobacion: 1,
        tipoValorResponsableId: responsibleStep.id.toString(),
        responsable: responsibleStep.label,
        aprobacionesTipoRolId: this.form.rolType,
        aprobacionesTipoPasoId: this.form.stepType,
        demoraMaxHoras: 0,
        desdePrecioMoneda: 'CLP',
        desdePrecio: 0,
        redirigirFlujo: 'Y',
        subrogadoId: '',
        subrogado: '',
        subrogadoDesde: '',
        subrogadoHasta: '',
        distributed: false,
        pagina: undefined,
        x: undefined,
        y: undefined,
      };
      if (stepConfig.requeridos) {
        step.configuration = { ...step.configuration, requeridos: {} };
        stepConfig.requeridos.forEach((requiredConfig) => {
          if (requiredConfig.default && !step.configuration.requeridos[requiredConfig.valor]) {
            step.configuration.requeridos[requiredConfig.valor] = requiredConfig.default;
          }
        });
      }
      this.steps.push(step);
      this.steps.forEach((stepX, index) => {
        const stepIndex = stepX;
        stepIndex.numeroPaso = index + 1;
        stepIndex.index = index;
      });
      this.stepsOriginal = [...this.steps];
      this.signatureSteps = this.steps
        .filter((step) => step.aprobacionesTipoRolId === RolTypes.SIGNER)
        .map((stepMap) => ({
          responsibleId: stepMap.id,
          responsible: stepMap.responsable,
          id: stepMap.id,
          stepType: stepMap.aprobacionesTipoPasoId,
          rolType: stepMap.aprobacionesTipoRolId,
          stepNumber: stepMap.numeroPaso,
          name: stepMap.responsable,
          page: stepMap.pagina || null,
          x: stepMap.x || null,
          y: stepMap.y || null
        }))
        .reduce((index, option) => ({
          ...index,
          [option.id]: option
        }), {});

      // Preservar officeType al resetear el formulario
      const currentOfficeType = this.form.officeType;
      this.form = {
        officeType: currentOfficeType, // Mantener el valor actual
        stepType: StepTypes.USER,
        groupStep: '',
        userStep: '',
        rolType: RolTypes.APPROVER
      };
      this.loading = false;
    }
  },
  created() {
    this.getStepTypes();
    this.getStepRoles();
    this.$emit('set-office-type', this.form.officeType);
    if (this.$route.params.view !== 'create') {
      this.mapData();
    }
  }
};
</script>

<style scoped lang="scss">
@import "steps";
.responsible {
  text-decoration: line-through;
}
</style>
